import { Controller } from 'react-hook-form';
import {
  Autocomplete,
  Checkbox,
  InputSize,
  InputText,
  SelectSize,
} from '@ui/src';
import { NewApplicationStatus } from '../../../../hoc/common/types';
import InfoRow from '../../common/info-row';
import { CorrespondenceAddressTypes } from './types';

import commonStyles from '../../common/styles.module.css';
import cn from '../styles.module.css';

const CorrespondenceAddress = ({
  control,
  setValue,
  isEditable,
  status,
  fields,
  countries,
  clearErrors,
  errors,
}: CorrespondenceAddressTypes) => (
  <>
    <div className={cn.cddBlockTitle}>Correspondence address</div>
    <div className={cn.cddBlockContentWrapper}>
      <div className={cn.cddBlockContent}>
        <div
          className={`${commonStyles.addressCheckboxWrapper} ${commonStyles.stepOneCheckboxWrapper} ${commonStyles.cddBlockContentCheckbox}`}
        >
          <Controller
            control={control}
            name="correspondenceAddressSameAsRegisteredAddress"
            defaultValue={false}
            render={({ field: { onChange, value } }) => (
              <Checkbox
                name="correspondenceAddressSameAsRegisteredAddress"
                type="checkbox"
                checked={value}
                onChange={(e) => {
                  onChange(e.target.checked);

                  if (e.target.checked) {
                    setValue('correspondenceAddress1', '');
                    setValue('correspondenceAddress2', '');
                    setValue('correspondenceCity', '');
                    setValue('correspondenceCountryId', '');
                    setValue('correspondencePostalCode', '');
                  }
                }}
                title="Coincides with the registered address"
                disabled={
                  !isEditable ||
                  Boolean(
                    status === NewApplicationStatus.ACCEPTED ||
                    status === NewApplicationStatus.DECLINED,
                  )
                }
                tabIndex={
                  !isEditable &&
                  Boolean(
                    status === NewApplicationStatus.ACCEPTED ||
                    status === NewApplicationStatus.DECLINED,
                  )
                    ? -1
                    : 0
                }
                labelClassName={cn.addressCheckbox}
              />
            )}
          />
        </div>
        {!fields?.correspondenceAddressSameAsRegisteredAddress && (
          <>
            <InfoRow title="Country" id="correspondenceCountryId" lessPadding>
              <Controller
                control={control}
                name="correspondenceCountryId"
                defaultValue=""
                render={({ field: { onChange, value } }) => (
                  <Autocomplete
                    name="correspondenceCountryId"
                    placeholder="Select country..."
                    list={countries}
                    value={value}
                    size={SelectSize.SMALL}
                    className={`${commonStyles.newApplicationAutocomplete} ${
                      status === NewApplicationStatus.ACCEPTED ||
                      status === NewApplicationStatus.DECLINED
                        ? commonStyles.newApplicationAutocompleteDisabled
                        : ''
                    }`}
                    disabled={
                      !isEditable ||
                      Boolean(
                        status === NewApplicationStatus.ACCEPTED ||
                        status === NewApplicationStatus.DECLINED,
                      )
                    }
                    tabIndex={
                      !isEditable &&
                      Boolean(
                        status === NewApplicationStatus.ACCEPTED ||
                        status === NewApplicationStatus.DECLINED,
                      )
                        ? -1
                        : 0
                    }
                    onChange={(e) => {
                      onChange(e);
                      clearErrors(['correspondenceCountryId']);
                    }}
                    error={errors?.correspondenceCountryId?.message}
                    borderless
                    fullWidth
                  />
                )}
              />
            </InfoRow>
            <InfoRow title="City" id="correspondenceCity" lessPadding>
              <Controller
                control={control}
                name="correspondenceCity"
                defaultValue=""
                render={({ field: { onChange, value } }) => (
                  <InputText
                    name="correspondenceCity"
                    placeholder="Enter city..."
                    value={value}
                    onChange={(e) => {
                      onChange(e);
                      clearErrors(['correspondenceCity']);
                    }}
                    size={InputSize.SMALL}
                    className="borderless"
                    disabled={
                      !isEditable ||
                      Boolean(
                        status === NewApplicationStatus.ACCEPTED ||
                        status === NewApplicationStatus.DECLINED,
                      )
                    }
                    tabIndex={
                      !isEditable &&
                      Boolean(
                        status === NewApplicationStatus.ACCEPTED ||
                        status === NewApplicationStatus.DECLINED,
                      )
                        ? -1
                        : 0
                    }
                    error={errors?.correspondenceCity?.message}
                  />
                )}
              />
            </InfoRow>
            <InfoRow
              title="Postal code"
              id="correspondencePostalCode"
              lessPadding
            >
              <Controller
                control={control}
                name="correspondencePostalCode"
                defaultValue=""
                render={({ field: { onChange, value } }) => (
                  <InputText
                    name="correspondencePostalCode"
                    placeholder="Enter postal code..."
                    value={value}
                    onChange={(e) => {
                      onChange(e);
                      clearErrors(['correspondencePostalCode']);
                    }}
                    size={InputSize.SMALL}
                    className="borderless"
                    disabled={
                      !isEditable ||
                      Boolean(
                        status === NewApplicationStatus.ACCEPTED ||
                        status === NewApplicationStatus.DECLINED,
                      )
                    }
                    tabIndex={
                      !isEditable &&
                      Boolean(
                        status === NewApplicationStatus.ACCEPTED ||
                        status === NewApplicationStatus.DECLINED,
                      )
                        ? -1
                        : 0
                    }
                    error={errors?.correspondencePostalCode?.message}
                  />
                )}
              />
            </InfoRow>
            <InfoRow title="Address 1" id="correspondenceAddress1" lessPadding>
              <Controller
                control={control}
                name="correspondenceAddress1"
                defaultValue=""
                render={({ field: { onChange, value } }) => (
                  <InputText
                    name="correspondenceAddress1"
                    placeholder="Enter address 1..."
                    value={value}
                    onChange={(e) => {
                      onChange(e);
                      clearErrors(['correspondenceAddress1']);
                    }}
                    size={InputSize.SMALL}
                    className="borderless"
                    disabled={
                      !isEditable ||
                      Boolean(
                        status === NewApplicationStatus.ACCEPTED ||
                        status === NewApplicationStatus.DECLINED,
                      )
                    }
                    tabIndex={
                      !isEditable &&
                      Boolean(
                        status === NewApplicationStatus.ACCEPTED ||
                        status === NewApplicationStatus.DECLINED,
                      )
                        ? -1
                        : 0
                    }
                    error={errors?.correspondenceAddress1?.message}
                  />
                )}
              />
            </InfoRow>
            <InfoRow title="Address 2" id="correspondenceAddress2" lessPadding>
              <Controller
                control={control}
                name="correspondenceAddress2"
                defaultValue=""
                render={({ field: { onChange, value } }) => (
                  <InputText
                    name="correspondenceAddress2"
                    placeholder="Enter address 2..."
                    value={value}
                    onChange={(e) => {
                      onChange(e);
                      clearErrors(['correspondenceAddress2']);
                    }}
                    size={InputSize.SMALL}
                    disabled={
                      !isEditable ||
                      Boolean(
                        status === NewApplicationStatus.ACCEPTED ||
                        status === NewApplicationStatus.DECLINED,
                      )
                    }
                    tabIndex={
                      !isEditable &&
                      Boolean(
                        status === NewApplicationStatus.ACCEPTED ||
                        status === NewApplicationStatus.DECLINED,
                      )
                        ? -1
                        : 0
                    }
                    className="borderless"
                    error={errors?.correspondenceAddress2?.message}
                  />
                )}
              />
            </InfoRow>
          </>
        )}
      </div>
    </div>
  </>
);

export default CorrespondenceAddress;
